module.exports = __webpack_public_path__ + "static/media/b1.eda44e6e.png";